import { PET_ITEM } from "@src/mock/data/pet";

export default {
  title: '取得會員寵物項目',
  type: 'get',
  body: [
    {
      title: '成功',
      body: {
        "code": 200,
        "message": "success",
        "status": "SUCCESS",
        "data": {
          "items": PET_ITEM,
        }
      }
    },
  ]
}

